<template>
  <div class="rounded-sm bg-surface-elevation-1 p-4 pb-6 shadow-sm">
    <div class="mb-4 ml-1 flex items-center text-headline-xs text-main">
      <LockIcon class="mr-1 lucide-icon-s text-icon-primary" />
      {{ t('Reviews.product.campaign.globalBudget.noBudget') }}
      <TooltipWrapper>
        <template #content>
          <div v-html="t('Reviews.product.campaign.globalBudget.learnMoreTooltip')" />
        </template>
        <template #trigger>
          <a
            href="https://hi.omr.com/de/success-hub/bonus-incentive-budget-incentives"
            target="_blank"
            @click="trackPlanExplore({ entity_type: 'tool', entity_id: entityId, placement: 'campaign_budget' })"
          >
            <CircleHelpIcon class="ml-1 lucide-icon-s text-icon-subtlest" />
          </a>
        </template>
      </TooltipWrapper>
    </div>
    <div>
      <span class="inline-block h-2 w-2 rounded-full bg-surface-alpha-elevation-5" />
      <span class="ml-1 text-label-m text-disabled">
        {{ t('Reviews.product.campaign.globalBudget.usedHint') }}
      </span>
    </div>
    <div class="mb-2 text-body-s text-disabled">
      <span class="text-headline-s">{{ used }}</span>
      /<span>{{ total }}</span>
    </div>
    <LinearProgress class="mb-6" percentage="outside" :progress="0" />
    <div class="flex justify-end">
      <a
        class="btn-primary-color-xs"
        :href="t('Reviews.product.campaign.globalBudget.unlockBudgetLink')"
        target="_blank"
        @click="trackPlanUpgrade({ entity_type: 'tool', entity_id: entityId, placement: 'campaign_budget' })"
      >
        <LockOpenIcon class="lucide-icon-s" />{{ t('Reviews.product.campaign.globalBudget.unlockBudget') }}
      </a>
    </div>
  </div>
</template>
<script setup lang="ts">
import { LinearProgress, TooltipWrapper, useCurrencyFormatter } from '@ramp106/omrjs-core-ui'
import { CircleHelpIcon, LockIcon, LockOpenIcon } from '@ramp106/omrjs-core-ui/icons'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { trackPlanExplore, trackPlanUpgrade } from '@/services/planCtaTracking'

defineProps<{ entityId: string }>()

const { t } = useI18n()
const { formatCurrency } = useCurrencyFormatter()

const total = computed(() => formatCurrency(Number(t('Reviews.product.campaign.globalBudget.mockedTotalBudget'))))
const used = computed(() => formatCurrency(0))
</script>
